import { ChangeLang } from "../changeLang/ChangeLangNav";
import { LoginSidebar } from "../mainsidebar/ui/loginsidebar";
import { ToggleButton } from "../mainsidebar/ui/ToggleButton";
import { Link, useLocation } from "react-router-dom";
import { Tooltip } from "antd";
import { ReactComponent as MainIcon } from './icons/main.svg'
import { ReactComponent as AnimalIcon } from './icons/animal.svg'
import { ReactComponent as PlantsIcon } from './icons/plants.svg'
import { ReactComponent as WaterIcon } from './icons/water.svg'
import { ReactComponent as EconomyIcon } from './icons/economy.svg'
import { ReactComponent as KurultaiIcon } from './icons/kurultai.svg'
import { ReactComponent as CameraIcon } from './icons/camera.svg'
import styles from './styles.module.css';
import { useSelector } from "react-redux";
import { getAuthState } from "../../redux/slices/authSlice";
import { RootState } from "../../redux/root/root-state.interface"; 

interface NavItem {
  icon: string | JSX.Element;
  tooltip: string;
  path: string;
  roles: string[];
}

interface MainNavBarProps {
  collapsed: boolean;
  onToggle?: () => void;
}

const MainNavBar: React.FC<MainNavBarProps> = ({ collapsed, onToggle }) => {
  const handleToggle = onToggle || (() => { });
  const location = useLocation();

  const userRoles = useSelector((state: RootState) => getAuthState(state).roles);
  const userRolesArray = userRoles?.map(role => role.alias.trim());
  
  const hasRequiredRole = (requiredRoles: string[]) => {
    if (!userRolesArray || !requiredRoles) return false;
    return requiredRoles.some(role => userRolesArray.includes(role));
  };



  const navItems: NavItem[] = [
    {
      icon: (
        <div className={styles.icons_inner}>
          <MainIcon className='svg-icon' width={40} height={40} />
        </div>
      ),
      tooltip: "Главная",
      path: "/",
      roles: ['SUPER_ADMIN', 'administrator','dep_guidance']
    },
    {
      icon: (
        <div className={styles.icons_inner}>
          <AnimalIcon className='svg-icon' width={40} height={40} />
        </div>
      ),
      tooltip: "Животноводство",
      path: "/animal",
      roles: ['SUPER_ADMIN', 'administrator', 'dep_animal','dep_guidance']
    },
    {
      icon: (
        <div className={styles.icons_inner}>
          <PlantsIcon className='svg-icon' width={40} height={40} />
        </div>
      ),
      tooltip: "Растениеводство",
      path: "/plantsales",
      roles: ['SUPER_ADMIN', 'administrator', 'dep_plants','dep_guidance']
    },
    {
      icon: (
        <div className={styles.icons_inner}>
          <WaterIcon className='svg-icon' width={40} height={40} />
        </div>
      ),
      tooltip: "Водные ресурсы",
      path: "/mapAndStatistics",
      roles: ['SUPER_ADMIN', 'administrator', 'dep_water','dep_guidance']
    },
    {
      icon: (
        <div className={styles.icons_inner}>
          <EconomyIcon className='svg-icon' width={40} height={40} />
        </div>
      ),
      tooltip: "ВЭД",
      path: "/economicactivity",
      roles: ['SUPER_ADMIN', 'administrator', 'dep_economy','dep_guidance']
    },
    {
      icon: (
        <div className={styles.icons_inner}>
          <KurultaiIcon className='svg-icon' width={40} height={40} />
        </div>
      ),
      tooltip: "Курултай",
      path: "/Kurultai",
      roles: ['SUPER_ADMIN', 'administrator','dep_guidance','kurultai_operator','kurultai_admin','kurultai_ministr']
    },
    {
      icon: (
        <div className={styles.icons_inner}>
          <CameraIcon className='svg-icon' width={40} height={40} />
        </div>
      ),
      tooltip: "Камера",
      path: "/camera",
      roles: ['SUPER_ADMIN', 'administrator','dep_guidance']
    }
  ].filter(item => hasRequiredRole(item.roles));

  return (
    <nav className={styles.navbar} data-collapsed={collapsed}>
      <div className={styles.left_side}>
        <ToggleButton isCollapsed={collapsed} onClick={handleToggle} />
        <div className={styles.nav_icons}>
          {navItems.map((item, index) => (
            <Tooltip key={index} title={item.tooltip} placement="bottom">
              <Link
                to={item.path}
                className={`${styles.nav_link} ${styles.menuItem} ${location.pathname === item.path ? styles.active : ''}`}
              >
                {typeof item.icon === "string" ? (
                  <img src={item.icon} alt={item.tooltip} className={styles.nav_icon} />
                ) : (
                  item.icon
                )}
              </Link>
            </Tooltip>
          ))}
        </div>
      </div>
      <ChangeLang />
      <LoginSidebar />
    </nav>
  );
};

export default MainNavBar;
